import { render, staticRenderFns } from "./iossRuleModal.vue?vue&type=template&id=2cfb433e&scoped=true"
import script from "./iossRuleModal.vue?vue&type=script&lang=js"
export * from "./iossRuleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfb433e",
  null
  
)

export default component.exports